(function () {'use strict';}());
angular.module("elidb").directive('familyPopover', function($document,$timeout) {
    return {
      restrict: 'A',
      link:function($scope,element,attr) {
        var trace = angular.trace;
        var iid = __STATE__ == "MA" ? 58 : 97;

        $scope.ldiagnosis = [{label: ($scope.tech.txtRefineSelectDiagnosis ? $scope.tech.txtRefineSelectDiagnosis.value : 'Select Diagnosis'),
        				id: 0}].concat($scope.diagnosis);
        
        $scope.temp = {age: getAge(),
        					diagnosis: getDiagnosis(),
        					insurance: $scope.savedFilters[iid] ? true : false,
        					language: $scope.savedFilters[110] ? true : false,
        };

        $scope.updateFamilyProfile = function() {
        	var prop, item;

        	if($scope.temp.age) {
        		for(prop in $scope.tempAgeGroup) {
        			delete $scope.tempAgeGroup[prop];
        		}
        		$scope.tempAgeGroup[$scope.temp.age.id] = true;

        		$scope.updateTagDependencies($scope.temp.age,$scope.tempAgeGroup); 
        		$scope.commit('age','AgeGroup');
        	} 

        	if($scope.temp.diagnosis) {
        		for(prop in $scope.tempDiagnosis) {
        			delete $scope.tempDiagnosis[prop];
        		}
        		if($scope.temp.diagnosis.id > 0) $scope.tempDiagnosis[$scope.temp.diagnosis.id] = true;
        		$scope.updateTagDependencies($scope.temp.diagnosis,$scope.tempDiagnosis); 
        		$scope.commit('diagnosis','Diagnosis');
        	}

        	var insurance = $scope.primaryFilters.filter(filterItem,{id: iid})[0];
        	$scope.tempFilters[insurance.id] = true;
        	if($scope.temp.insurance) {
        		$scope.tempFilters[insurance.id] = true;
        		$scope.updateTagDependencies(insurance,$scope.tempFilters); 
        		$scope.filterSelect();
        	} else {
        		delete $scope.tempFilters[insurance.id];
        		$scope.updateTagDependencies(insurance,$scope.tempFilters); 
        		$scope.filterSelect();
        	}
        	

        	var language = $scope.primaryFilters.filter(filterItem,{id: 110})[0];
        	$scope.tempFilters[language.id] = true;
        	if($scope.temp.language) {
        		$scope.tempFilters[language.id] = true;
        		$scope.updateTagDependencies(language,$scope.tempFilters); 
        		$scope.filterSelect();
        	} else {
        		delete $scope.tempFilters[language.id];
        		$scope.updateTagDependencies(language,$scope.tempFilters); 
        		$scope.filterSelect();
        	}

        	$scope.cancel();
        };

        $scope.cancel = function($event) {
        	if($event) {
        		$event.preventDefault();
        		$event.stopImmediatePropagation();
        	}
        	
        	$scope.toggleFamilyPopover();
        };

        function getDiagnosis() {
        	for(var i = 0, count = $scope.diagnosis.length; i < count; i++) {
        		var item = $scope.diagnosis[i];
        		if($scope.savedDiagnosis[item.id]) return item;
			}

        	return $scope.ldiagnosis[0];
        }

        function getAge() {
        	for(var i = 0, count = $scope.age.length; i < count; i++) {
        		var item = $scope.age[i];
        		if($scope.savedAgeGroup[item.id]) return item;
			}

        	return $scope.ldiagnosis[0];
        }

        function filterItem(e) {
        	if(e.id === this.id) return true;
        	return false;
        }
      }  
    };
  });